/**
 * StaticTranslateLoader
 *
 * Carga las traducciones directamente como módulos TypeScript importados,
 * sin necesidad de peticiones HTTP. Esto lo hace 100% compatible con
 * Angular SSR (no depende de un servidor corriendo para hacer GET /assets).
 *
 * Uso: registrar en app.config.ts como loader de TranslateModule.forRoot()
 */
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import esTranslations from '../../assets/i18n/es.json';
import enTranslations from '../../assets/i18n/en.json';

const TRANSLATIONS: Record<string, object> = {
  es: esTranslations,
  en: enTranslations,
};

export class StaticTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<object> {
    return of(TRANSLATIONS[lang] ?? TRANSLATIONS['es']);
  }
}
